module.exports = __webpack_public_path__ + "static/media/18-receipt.b28bc92f.png";